import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import Account from './Account/Account';
import {
  Table,
  HealthPoint,
  TablePerson
} from 'components/common/Elements/Elements';
import Cell from './Cell/Cell';

import { moneyFormater } from 'utils/common';

import classes from './SatisfactionBoardTable.module.scss';

const TableRow = ({ company, tableConf, row, mouseEnter }) => {
  const { t } = useTranslation(['activity']);

  const big =
    company.industry !== '-' ||
    company.department !== '-' ||
    company.industry !== 'NA' ||
    company.department !== 'NA';

  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          big: big
        };

        return (
          <Fragment key={`${title}-${company.email}}`}>
            {show && field === 'companyName' && (
              <Cell cellProps={cellProps}>
                <Account data={company} />
              </Cell>
            )}
            {show && field === 'plan' && (
              <Cell cellProps={cellProps}>{company.plan}</Cell>
            )}
            {show && field === 'healthPoint' && (
              <Cell cellProps={cellProps}>
                <HealthPoint
                  data={{
                    point: company.healthPoint,
                    status: company.healthStatus
                  }}
                />
              </Cell>
            )}
            {show && field === 'arr' && (
              <Cell cellProps={cellProps}>{moneyFormater(company.arr)}</Cell>
            )}
            {show && field === 'npsScore' && (
              <Cell cellProps={cellProps}>
                {company.npsScore ? company.npsScore : 'NA'}
              </Cell>
            )}
            {show && field === 'openTickets' && (
              <Cell cellProps={cellProps}>{company.openTickets}</Cell>
            )}
            {show && field === 'csatChatScore' && (
              <Cell cellProps={cellProps}>
                {company.csatChatScore > 0 ? company.csatChatScore : 'NA'}
              </Cell>
            )}
            {show && field === 'csatTicketScore' && (
              <Cell cellProps={cellProps}>
                {company.csatTicketScore > 0 ? company.csatTicketScore : 'NA'}
              </Cell>
            )}
            {show && field === 'csatTicketNum' && (
              <Cell cellProps={cellProps}>{company.csatTicketNum}</Cell>
            )}
            {show && field === 'csatChatNum' && (
              <Cell cellProps={cellProps}>{company.csatChatNum}</Cell>
            )}
            {show && field === 'customerSuccessEngineer' && (
              <Cell cellProps={cellProps} classNameContent={classes.center}>
                {company.customerSuccessEngineer !==
                t('activity:customers:UNASSIGNED') ? (
                  <TablePerson person={company.customerSuccessEngineer} />
                ) : (
                  t('activity:customers:UNASSIGNED')
                )}
              </Cell>
            )}
            {show && field === 'accountManager' && (
              <Cell cellProps={cellProps} classNameContent={classes.center}>
                {company.accountManager !==
                t('activity:customers:UNASSIGNED') ? (
                  <TablePerson person={company.accountManager} />
                ) : (
                  t('activity:customers:UNASSIGNED')
                )}
              </Cell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
